import { createApi } from '@/api'
export default {
	getDictList: config => createApi( `/dictionary/pageSearch`, 'post', config ),
	dictDetail: config => createApi(`/dictionary/get`, 'get', config),
	adddict: config => createApi(`/dictionary/add`, 'post', config),
	deletedict: config => createApi(`/dictionary/delete`, 'delete', config),
	updatedict: config => createApi(`/dictionary/update`, 'post', config),
	getDictTypeList: config => createApi( `/dictionary/getDictType`, 'get', config )
}



// WEBPACK FOOTER //
// ./src/views/dictManage/api/index.js